<template>
  <div id="Footer">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="10" :md="10" :lg="10" :xl="10">
        <el-col :xs="8" :sm="5" :md="5" :lg="5" :xl="5">
          <div id="meum_nav1">
            <div><label>展览</label></div>
            <div id="vborder1"></div>
            <router-link tag="div" :to="{path:'/exhibitioninfo/permanent'}">常设展览</router-link>
            <router-link tag="div" :to="{path:'/exhibitioninfo/thematic'}">专题展览</router-link>
            <router-link tag="div" :to="{path:'/exhibitioninfo/exchange'}">交流展览</router-link>
            <router-link tag="div" :to="{path:'/exhibitioninfo/vr'}">数字展览</router-link>
            <router-link tag="div" :to="{path:'/exhibitioninfo/micro'}">微展览</router-link>
          </div>
        </el-col>
        <el-col :xs="8" :sm="5" :md="5" :lg="5" :xl="5">
          <div id="meum_nav2">
            <div><label>馆藏</label></div>
            <div id="vborder2"></div>
            <div @click="goTo1()">金银器</div>
            <div @click="goTo2()">铜器</div>
            <div @click="goTo3()">陶器</div>
            <div @click="goTo4()">骨角牙器</div>
            <div @click="goTo5()">书法、绘画</div>
            <div @click="goTo6()">乐器、法器</div>
            <div @click="goTo7()">雕塑、造像</div>
            <div @click="goTo8()">钱币</div>
          </div>
        </el-col>
        <el-col :xs="8" :sm="5" :md="5" :lg="5" :xl="5">
          <div id="meum_nav3">
            <div><label>文创</label></div>
            <div id="vborder3"></div>
            <router-link tag="div" :to="{path:'/Wenchuang'}">精品文创</router-link>
          </div>
        </el-col>
        <el-col :xs="8" :sm="5" :md="5" :lg="5" :xl="5">
          <div id="meum_nav4">
            <div><label>资讯</label></div>
            <div id="vborder4"></div>
            <router-link tag="div" :to="{path:'/informations/qbdynamic'}">青博动态</router-link>
            <router-link tag="div" :to="{path:'/informations/qbnews'}">文博要闻</router-link>
            <router-link tag="div" :to="{path:'/informations/inner'}">党建工作</router-link>
          </div>
        </el-col>
        <el-col :xs="8" :sm="4" :md="4" :lg="4" :xl="4">
          <div id="meum_nav5">
            <div><label>关于</label></div>
            <div id="vborder5"></div>
            <router-link tag="div" :to="{path:'/about/introduction'}">青博介绍</router-link>
            <router-link tag="div" :to="{path:'/about/qbconstitution'}">青博章程</router-link>
            <router-link tag="div" :to="{path:'/about/contact'}">交通指南</router-link>
          </div>
        </el-col>
      </el-col>
      <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="4">
        <div id="Address">
          <div>
            <div class="p-text">咨询电话：0971—6111326（周二至周天  早上9：00—下午17：00）</div>
            <div class="p-text"> 0971—6111164（周一  早上8：40—11：50  下午14：40—17：50）</div>
          </div>
          <div class="p-text">
            <span>地址：青海省西宁市城西区西关大街58号</span>
          </div>
          <div class="p-text">友情链接</div>
          <div class="p-text">
            <el-select v-model="value1" @change="JupUrl" placeholder="博物馆相关链接">
              <el-option v-for="item in optionsmu" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div style="padding-top:10px">
            <el-select v-model="value2" @change="JupUrlZf" placeholder="政府相关链接">
              <el-option v-for="item in optionszf" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="10" :md="10" :lg="10" :xl="10">
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <div class="w_ewm">
            <img style="width: 200px;height: 200px;" src="../assets/homeimage/qb8.png">
          </div>
          <div>微信公众号</div>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <div class="w_ewm">
            <img style="width: 200px;height: 200px;" src="../assets/yy.jpg">
          </div>
          <div>门票预约（个人）</div>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <div class="w_ewm">
            <img style="width: 200px;height: 200px;" src="../assets/tyy.jpg">
          </div>
          <div>门票预约（团队）</div>
        </el-col>
      </el-col>
    </el-row>
    <div id="wFour">
      <div>网站访问量<span style="display: inline-block; vertical-align: middle; margin-left: 10px;" class="foinner" v-html="count"></span></div>
      <div>©CopyRight 青海省博物馆 All Rights Reserved. 青ICP备13000424号</div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        optionsmu: [{
            value: 'http://www.dpm.org.cn/',
            label: '故宫博物院'
          },
          {
            value: 'http://www.chnmuseum.cn/',
            label: '中国国家博物馆'
          },
          {
            value: 'http://www.capitalmuseum.org.cn/',
            label: '首都博物馆'
          },

          {
            value: 'http://www.bmnh.org.cn/',
            label: '北京自然博物馆'
          },
          {
            value: 'http://www.chinamuseum.org.cn/',
            label: '中国博物馆协会'
          },
          {
            value: 'http://www.sach.gov.cn/',
            label: '国家文物局'
          }
        ],
        value1: '',

        optionszf: [{
            value: 'http://www.qh.gov.cn/',
            label: '青海省人民政府'
          },
          {
            value: 'http://whlyt.qinghai.gov.cn/',
            label: '青海省文化和旅游厅'
          },
          {
            value: 'http://www.qhkj.gov.cn/',
            label: '青海省科技厅'
          },
          {
            value: 'http://www.qhjyt.gov.cn/',
            label: '青海省教育厅'
          }
        ],
        value2: '',
        tableData: [],
        loading: false,
        count: ''
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("Footer").style.display = "none";
        document.getElementById("wFour").style.display = "none"
      };
      this.counts();
      this.search()
    },
    methods: {
      goTo1() {
        this.$router.push({
          path: '/collection/ceramics',
          query: {
            id: 101,
            title: '金银器'
          }
        });
      },
      goTo2() {
        this.$router.push({
          path: '/collection/ceramics',
          query: {
            id: 102,
            title: '铜器'
          }
        });
      },
      goTo3() {
        this.$router.push({
          path: '/collection/ceramics',
          query: {
            id: 104,
            title: '陶器'
          }
        });
      },
      goTo4() {
        this.$router.push({
          path: '/collection/ceramics',
          query: {
            id: 103,
            title: '骨角牙器'
          }
        });
      },
      goTo5() {
        this.$router.push({
          path: '/collection/ceramics',
          query: {
            id: 106,
            title: '书法、绘画'
          }
        });
      },
      goTo6() {
        this.$router.push({
          path: '/collection/ceramics',
          query: {
            id: 110,
            title: '乐器、法器'
          }
        });
      },
      goTo7() {
        this.$router.push({
          path: '/collection/ceramics',
          query: {
            id: 112,
            title: '雕塑、造像'
          }
        });
      },
      goTo8() {
        this.$router.push({
          path: '/collection/ceramics',
          query: {
            id: 111,
            title: '钱币'
          }
        });
      },
      JupUrl(value) {
        window.open(this.value1)
      },
      JupUrlZf(value) {
        window.open(this.value2)
      },
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      counts: function() {
        let that = this;
        let url = this.HOST + '/api/v1/browse/browse';
        that.loading = true;
        this.$axios.put(url).then(function(result) {
          let cData = result.data;
        }).catch(function(error) {
          console.log(err);
        })
      },
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/browse/browseOne';
        that.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.tableData = cData.data;
          that.count = "<i>" + that.tableData.counts.toString().split("").join("</i><i>") + "</i>";
        }).catch(function(error) {
          console.log(err);
        })
      }
    }

  }
</script>

<style scoped>
  #Footer {
    height: 100%;
  }

  #hThree {
    margin-top: 2em;
    overflow: hidden;
  }

  #wThree {
    height: 450px;
    background: #F8F8FF;
  }

  #wSecondContent {
    height: 350px;
  }

  #wNavlist,
  #weixin{
    height: 350px;
  }

  .hborder1 {
    height: 380px;
    width: 1px;
    margin-top: 35px;
    border-left: 1px solid #DEDEDE;
  }

  #wqb {
    margin-right: 30px;
    margin-left: 30px;
    margin-top: 30px;
    background: #FF5500;
  }

  #wqb>img {
    width: 100%;
    height: 100%;
  }

  #sqb {
    margin: 5px 30px;
    overflow: hidden;
  }

  #sqb>img {
    width: 100%;
    height: 100%;
  }

  #Address>div:nth-child(1) {
    margin-top: 20px;
  }


  #wFour {
    height: 120px;
    background: #606266;
    overflow-y: hidden;
    width: 100%;
  }

  #wFour>div {
    color: #ffffff;
    line-height: 40px;
  }

  #wFour>div:nth-child(1) {
    padding-top: 20px;
  }

  #wFour>div:nth-child(2)>span>i {
    font-style: normal;
    width: 20px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background: #404040;
    margin: 0 3px;
    display: inline-block;
  }

  #wThree>div:nth-child(3)>div:nth-child(1) {
    line-height: 60px;
  }

  #wThree>div:nth-child(3)>div:nth-child(2) {
    border-top: 1px solid #dedede;
    width: 80%;
    margin-top: 1em;
    margin-left: 10%;
  }

  #wThree>div:nth-child(3)>div:nth-child(3) {
    width: 200px;
    height: 200px;
    margin-left: 25%;
    border: 1px solid #dedede;
    margin-top: 1.5em;
  }

  #wThree>div:nth-child(3)>div:nth-child(4) {
    width: 150px;
    height: 30px;
    margin-left: 30%;
    margin-top: 0.5em;
  }

  #wThree>div:nth-child(3)>div:nth-child(3)>img,
  #wThree>div:nth-child(3)>div:nth-child(4)>img {
    width: 100%;
    height: 100%;
  }

  #meum_nav1>div:nth-child(1),
  #meum_nav2>div:nth-child(1),
  #meum_nav3>div:nth-child(1),
  #meum_nav4>div:nth-child(1),
  #meum_nav5>div:nth-child(1) {
    font-size: 1.2em;
    line-height: 60px;
    font-weight: 600;
    margin-top: 10px;
  }

  #meum_nav1>div:nth-child(3),
  #meum_nav1>div:nth-child(5),
  #meum_nav1>div:nth-child(4),
  #meum_nav1>div:nth-child(6),
  #meum_nav1>div:nth-child(7) {
    font-size: 1em;
    line-height: 45px;
    cursor: pointer;
  }

  #meum_nav2>div:nth-child(3),
  #meum_nav2>div:nth-child(4),
  #meum_nav2>div:nth-child(5),
  #meum_nav2>div:nth-child(6),
  #meum_nav2>div:nth-child(7),
  #meum_nav2>div:nth-child(8),
  #meum_nav2>div:nth-child(9),
  #meum_nav2>div:nth-child(10) {
    font-size: 1em;
    line-height: 45px;
    cursor: pointer;
  }

  #meum_nav3>div:nth-child(3) {
    font-size: 1em;
    line-height: 45px;
    cursor: pointer;
  }

  #meum_nav4>div:nth-child(3),
  #meum_nav4>div:nth-child(5) {
    font-size: 1em;
    line-height: 45px;
    cursor: pointer;
  }

  #meum_nav5>div:nth-child(3),
  #meum_nav5>div:nth-child(5),
  #meum_nav5>div:nth-child(7),
  #meum_nav5>div:nth-child(7),
  #meum_nav5>div:nth-child(9) {
    font-size: 1em;
    line-height: 45px;
    cursor: pointer;
  }

  #meum_nav1>div:hover,
  #meum_nav2>div:hover,
  #meum_nav3>div:hover,
  #meum_nav4>div:hover,
  #meum_nav5>div:hover {
    color: #FF4500;
  }

  #vborder1,
  #vborder2,
  #vborder3,
  #vborder4,
  #vborder5 {
    height: 2px;
    background: #0066CC;
  }


  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .w_ewm{
    margin: auto;
  }

  .p-text{
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue